import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { getMeAdmin } from '../fitur/AuthSlice';
import { Layout } from './Layout';

/**
 * Wrapper halaman yang membutuhkan sesi login aktif.
 */
export const ProtectedPage = ({ children }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isError } = useSelector((state) => state.authAdmin);

  useEffect(() => {
    dispatch(getMeAdmin());
  }, [dispatch]);

  useEffect(() => {
    if (isError) {
      navigate('/login', { replace: true });
    }
  }, [isError, navigate]);

  return <Layout>{children}</Layout>;
};

export default ProtectedPage;
